<template>
  <v-row>
    <v-col lg="4" cols="12">
      <!-- Profile Card Will be Here  -->
      <ProfileCard
        :user="socialSocialUser"
        v-bind:isProfile="true"
        :isMine="false"
      />
    </v-col>
    <v-col lg="8" cols="12">
      <v-card>
        <div class="pa-4">
          <h4>Bio</h4>
        </div>
        <v-divider></v-divider>
        <div class="pa-4">
          <small>
            {{ socialSocialUser.my_bio ? socialSocialUser.my_bio : "N/A" }}
          </small>
        </div>
      </v-card>

      <div class="mt-4"></div>
      <v-card>
        <div class="pa-4">
          <div class="d-flex align-center">
            <b>Country</b>
            <small class="ml-auto">{{
              socialSocialUser.country ? socialSocialUser.country : "N/A"
            }}</small>
          </div>
          <div class="d-flex align-center">
            <b>City</b>
            <small class="ml-auto">{{
              socialSocialUser.city ? socialSocialUser.city : "N/A"
            }}</small>
          </div>
          <div class="d-flex align-center">
            <b>Sub Genre</b>
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(genre, k) of socialSocialUser.sub_genre"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == socialSocialUser.sub_genre.length - 1,
                }"
                >{{ genre }}</v-chip
              >
            </v-chip-group>
            <div
              class="ml-auto"
              v-if="
                !socialSocialUser.sub_genre ||
                socialSocialUser.sub_genre.length == 0
              "
            >
              N/A
            </div>
          </div>

          <div class="d-flex align-center">
            <b>Skills</b>

            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(instrument, k) of socialSocialUser.skills"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == socialSocialUser.skills.length - 1,
                }"
                >{{ instrument }}</v-chip
              >
            </v-chip-group>
            <div
              class="ml-auto"
              v-if="
                !socialSocialUser.skills || socialSocialUser.skills.length == 0
              "
            >
              N/A
            </div>
          </div>

          <div class="d-flex align-center">
            <b>Creating Since</b>
            <small class="ml-auto">{{
              socialSocialUser.creating_since
                ? socialSocialUser.creating_since
                : "N/A"
            }}</small>
          </div>
          <div class="d-flex flex-wrap align-center">
            <b style="flex-shrink: 0" class="mr-4"
              >Performing Rights Organization</b
            >
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(
                  pro, k
                ) of socialSocialUser.performing_rights_organization"
                :key="k"
                x-small
                :class="{
                  'mr-0':
                    k ==
                    socialSocialUser.performing_rights_organization.length - 1,
                }"
                >{{ pro }}</v-chip
              >
            </v-chip-group>
            <div
              class="ml-auto"
              v-if="
                !socialSocialUser.performing_rights_organization ||
                socialSocialUser.performing_rights_organization.length == 0
              "
            >
              N/A
            </div>
          </div>
          <div class="d-flex align-center">
            <b>Label</b>
            <small class="ml-auto">{{
              socialSocialUser.label ? socialSocialUser.label : "N/A"
            }}</small>
          </div>
          <div class="d-flex align-center">
            <b>Sounds Like</b>
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(sound_like, k) of socialSocialUser.sounds_like"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == socialSocialUser.sounds_like.length - 1,
                }"
                >{{ sound_like }}</v-chip
              >
            </v-chip-group>
            <div
              class="ml-auto"
              v-if="
                !socialSocialUser.sounds_like ||
                socialSocialUser.sounds_like.length == 0
              "
            >
              N/A
            </div>
          </div>
        </div>
      </v-card>
      <div class="mt-4"></div>
      <CreatorType
        :creator_type="
          socialSocialUser.creator_type ? socialSocialUser.creator_type : []
        "
      />
      <div class="mt-4"></div>
      <MusicVideos
        :videos="
          socialSocialUser.music_videos ? socialSocialUser.music_videos : []
        "
        :allowAdd="false"
      />
      <div class="mt-4"></div>
      <MusicReference
        :references="
          socialSocialUser.streaming_links
            ? socialSocialUser.streaming_links
            : []
        "
        :allowAdd="false"
      />
      <div class="mt-4"></div>
      <SocialCredits
        :audio="
          socialSocialUser.audio_references
            ? socialSocialUser.audio_references
            : []
        "
        :allowAdd="false"
      />
      <div class="mt-4"></div>
      <SocialLinks
        :links="
          socialSocialUser.social_links ? socialSocialUser.social_links : []
        "
        :allowAdd="false"
      />
      <div class="mt-4"></div>
    </v-col>
  </v-row>
</template>

<script>
import ProfileCard from "../components/ProfileCard.vue";
import CreatorType from "../components/profile/CreatorType.vue";
import MusicVideos from "../components/profile/MusicVideos.vue";
import MusicReference from "../components/profile/MusicReference.vue";
import AboutYou from "../components/profile/AboutYou.vue";
import SocialLinks from "../components/profile/SocialLinks.vue";
import SocialCredits from "../components/profile/SocialCredits.vue";

export default {
  name: "Profile",
  data() {
    return {
      completeProfile: false,
    };
  },
  mounted() {
    let userId = this.$router.currentRoute.params.id;
    console.log({ userId });
    this.getSocialUser(userId);
  },
  components: {
    ProfileCard,
    AboutYou,
    CreatorType,
    MusicVideos,
    MusicReference,
    SocialLinks,
    SocialCredits,
  },
  beforeMount() {
    let completeProfile = this.$route.query.completeProfile;
    this.completeProfile = completeProfile === "true";
  },
};
</script>
